var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.forDenomination
        ? _c("h1", [_vm._v(_vm._s(_vm.$t("setup.status.header")))])
        : _vm._e(),
      _vm._v(" "),
      _vm.forDenomination
        ? _c("h1", [_vm._v(_vm._s(_vm.$t("setup.status.headerDenomination")))])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "ct-card" }, [
        _c("section", { staticClass: "top-margin" }, [
          _vm.showError
            ? _c(
                "div",
                {
                  staticClass: "ct-text alert alert-danger",
                  attrs: { role: "alert" }
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.errorMessage) +
                      "\n            "
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.showError
            ? _c("div", { staticClass: "ct-text" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("setup.status.description")) +
                    "\n            "
                )
              ])
            : _vm._e()
        ]),
        _vm._v(" "),
        _c("section", { staticClass: "ct-action" }, [
          !_vm.showError
            ? _c("div", { staticClass: "progress" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "progress-bar progress-bar-success progress-bar-striped active",
                    style: { width: _vm.progressValue + "%" },
                    attrs: {
                      role: "progressbar",
                      "aria-valuenow": _vm.progressValue,
                      "aria-valuemin": "0",
                      "aria-valuemax": "100"
                    }
                  },
                  [
                    _c("span", { staticClass: "sr-only" }, [
                      _vm._v("45% Complete")
                    ])
                  ]
                )
              ])
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c("captera", {
        attrs: {
          capteraKey: "0e7f654b741c11525ae05c9c309c910b",
          vid: "2110740"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3bcb3770", { render: render, staticRenderFns: staticRenderFns })
  }
}